<template></template>

<script>
import GenericModal from '@/components/shared/elements/modal/GenericModal';

export default {
  methods: {
    showGenericModal(texts, options) {
      const bindingData = {
        bind: {
          is: GenericModal,
          titleText: texts.title,
          description: texts.description,
          time: texts.time,
          descriptionEnd: texts.descriptionEnd,
        },
      };
      if (options) {
        for (const [key, value] of Object.entries(options)) {
          bindingData.bind[key] = value;
        }
      }
      this.$eventBus.showModal(bindingData);
    },
  },
};
</script>
